import { Smartphone } from 'lucide-react';
import { Card } from './ui';
import { CopyButton } from './CopyButton';

/**
 * What the customer's people type at the first launch of the Firmio app: the
 * organization code (the tenant's slug). The app looks it up here and
 * connects to https://<domain>. The deep link pre-fills the code, handy in a
 * welcome email or a QR code.
 */
export function MobileAppCard({ slug, domain }: { slug: string; domain: string }) {
  const deepLink = `firmio://connect?code=${encodeURIComponent(slug)}`;
  return (
    <Card className="space-y-4">
      <div className="flex items-start gap-3">
        <Smartphone className="mt-0.5 h-5 w-5 text-violet-300" />
        <div>
          <h2 className="text-sm font-semibold text-white">Aplicația mobilă</h2>
          <p className="mt-1 text-xs text-slate-400">
            Utilizatorii introduc acest cod la prima pornire a aplicației Firmio. Aplicația se
            conectează apoi la <span className="text-slate-300">https://{domain}</span>.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-800 bg-slate-950 px-4 py-3">
        <div>
          <span className="block text-xs uppercase tracking-wide text-slate-400">
            Codul organizației
          </span>
          <span className="font-mono text-2xl font-semibold tracking-wide text-white">{slug}</span>
        </div>
        <CopyButton text={slug} label="Copiază codul organizației" />
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <span className="block text-xs uppercase tracking-wide text-slate-400">
            Link care precompletează codul (email, QR)
          </span>
          <code className="block truncate text-sm text-slate-300">{deepLink}</code>
        </div>
        <CopyButton text={deepLink} label="Copiază linkul aplicației" />
      </div>
    </Card>
  );
}
